/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Form_StartInputs */

const en_cp_form_start = /** @type {(inputs: Cp_Form_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting semester`)
};

const id_cp_form_start = /** @type {(inputs: Cp_Form_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semester mulai`)
};

/**
* | output |
* | --- |
* | "Starting semester" |
*
* @param {Cp_Form_StartInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_form_start = /** @type {((inputs?: Cp_Form_StartInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Form_StartInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_form_start(inputs)
	return en_cp_form_start(inputs)
});